import * as React from 'react';
import {FileType} from 'api/library';
import {EstimateType, TaskObject, TaskProgressType} from 'api/task/types';
import {TaskViewer} from 'components/TaskViewer';
import {IconLoading} from 'icons';
import {Helmet} from 'react-helmet';

/**
 * The view task page
 * @constructor
 */
export default function ViewTask(): React.ReactElement {
  const [
    task, setTask,
  ] = React.useState<TaskObject | undefined>(undefined);

  React.useEffect(() => {
    setTask({
      id: '',
      preview: {
        id: '60d45d980094de00338d917c',
        url: '/api/files/60d45d980094de00338d917c',
        type: FileType.Image,
      },
      status: 'draft',
      title: 'Маркетинговая информация и система маркетинговых исследований ',
      description: 'За последние пять лет мир маркетинга изменился коренным образом. На смену «доступным» быстрорастущим рынкам пришли зрелые, медленнорастущие модели спроса.',
      tags: ['Исследования', 'Система маркетинга'],
      authorId: '608d5909602da600dd89b40c',
      settings: {
        estimate: {
          type: EstimateType.Five,
          points: [0, 0, 0, 0, 100],
        },
      },
      progress: {
        status: TaskProgressType.Success,
      },
      content: {
        blocks: [],
      },
    });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Просмотр задания</title>
      </Helmet>
      {task ? (
        <TaskViewer
          task={task}
        />
      ) : <IconLoading />}
    </React.Fragment>
  );
}
